import "../navigation.css";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MasterIndex } from "verdi-web-client";
import { NAMESPACES } from "@/i18n/constants";

import FocusContext from "../../../services/map-management/focus-context";

/** Stable Select value for "all fields"; label text is translated separately. */
const ALL_FIELDS_VALUE = "all-fields";

function getSelectedValue(selectedAOI: { id: string } | undefined) {
    return selectedAOI === undefined ? ALL_FIELDS_VALUE : selectedAOI.id;
}

export function AOISelect() {
    const { t } = useTranslation(NAMESPACES.PAGES.MAP, { keyPrefix: "map-control-bar.field-select" });

    const allFieldsOption = t("all-fields");

    const [selectedAOI, setSelectedAOI] = useState(() => getSelectedValue(FocusContext.selectedAOI));

    const onSelectAOI = (e: { target: { value: string } }) => {
        const value = e.target.value;
        setSelectedAOI(value);
        const newAOI = value === ALL_FIELDS_VALUE ? undefined : MasterIndex.aoi.all.find((aoi) => aoi.id === value);
        FocusContext.setAOI(newAOI);
    };

    // Keep in sync when the selected AOI changes outside this control (map, URL params, etc.)
    useEffect(() => {
        const aoiChangeListener = () => {
            const currentValue = getSelectedValue(FocusContext.selectedAOI);
            if (currentValue !== selectedAOI) {
                setSelectedAOI(currentValue);
            }
        };

        FocusContext.onAOIChange.addListener(aoiChangeListener);

        return () => {
            FocusContext.onAOIChange.removeListener(aoiChangeListener);
        };
    }, [selectedAOI]);

    return (
        <FormControl variant={"filled"} style={{ zIndex: 1400 }}>
            {/* The color overrides the behaviour of the MUI default of turning it into the primary on click */}
            <InputLabel id={"aoi-select"} color={"dark" as any}>
                {t("field")}
            </InputLabel>
            <Select
                disableUnderline // removes the underline of the select so that it is consistent with the AccountSelect Select in the Drawer
                style={{ zIndex: 1400 }}
                className={"nav-drawer-select"}
                labelId={"aoi-select"}
                displayEmpty
                onChange={onSelectAOI}
                value={selectedAOI}
                renderValue={(value) => {
                    if (value === ALL_FIELDS_VALUE) {
                        return <em>{allFieldsOption}</em>;
                    }
                    return MasterIndex.aoi.all.find((aoi) => aoi.id === value)?.name ?? value;
                }}
            >
                <MenuItem value={ALL_FIELDS_VALUE}>
                    <em>{allFieldsOption}</em>
                </MenuItem>
                {MasterIndex.aoi.all &&
                    MasterIndex.aoi.all.map((aoi) => (
                        <MenuItem key={`NavBarMobileAcounts${aoi.id}`} value={aoi.id}>
                            {aoi.name}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
}
